import { Link } from 'react-router-dom';
import { GenericCatalogTable } from "../../../components/generic-catalog-table";
import { ScrollReveal } from "../../../components/scroll-reveal";
import { IRDAI_CONTROLS, IRDAI_DOMAINS } from "../../../data/irdai-controls";

export default function IrdaiFramework() {
  const columns = [
    { accessorKey: "controlId", header: "Control ID", size: 120 },
    { accessorKey: "domain", header: "Domain", size: 220 },
    { accessorKey: "requirement", header: "Control Requirement", size: 260 },
    { accessorKey: "insuranceContext", header: "Insurance Context", size: 260 },
    { accessorKey: "minimumBaseline", header: "Minimum Baseline", size: 260 },
    { accessorKey: "evidence", header: "Evidence", size: 220 },
    { accessorKey: "owner", header: "Owner", size: 140 },
    { accessorKey: "frequency", header: "Frequency", size: 140 },
    { accessorKey: "technologyEnablers", header: "Technology Enablers", size: 220 },
    { accessorKey: "testMethod", header: "Test Method", size: 200 },
    { accessorKey: "commonFindings", header: "Common Findings", size: 220 },
    { accessorKey: "severity", header: "Severity", size: 120 },
    { accessorKey: "automation", header: "Automation", size: 140 },
  ];
  return (
    <div>
      <section className="relative overflow-hidden py-16" style={{ background: "var(--gradient-hero)" }}>
        <div className="pointer-events-none absolute inset-0">
          <div className="aurora" />
          <div className="noise" />
        </div>

        <div className="container-ivalue relative">
          <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
            Indian Regulatory Frameworks / IRDAI
          </div>

          <h1 className="mt-4 text-balance text-4xl font-extrabold tracking-[-0.03em] text-text-primary md:text-6xl">
            IRDAI Cybersecurity
            <br />
            Guidelines for Insurers
          </h1>

          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-text-secondary">
            Protecting policyholder data and ensuring operational resilience for life,
            general, and health insurance companies.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#irdai-catalog"
              className="focus-ring sheen inline-flex h-12 items-center justify-center rounded-xl bg-gradient-to-r from-[#10B981] to-[#059669] px-5 text-sm font-semibold text-white transition-transform hover:scale-[1.02] active:scale-[0.98]"
            >
              Download IRDAI Catalog
            </a>
            <a
              href="#insurance-controls"
              className="focus-ring inline-flex h-12 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-5 text-sm font-semibold text-text-primary transition-colors hover:bg-white/10"
            >
              View Insurance-Specific Controls
            </a>
            <Link
              to="/frameworks/india/rbi"
              className="focus-ring inline-flex h-12 items-center justify-center rounded-xl px-5 text-sm font-semibold text-[color:var(--text-link)] transition-colors hover:text-text-primary"
            >
              Back to RBI →
            </Link>
          </div>

          <div className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {[
              { k: "Domains", v: "10" },
              { k: "Controls", v: "70+" },
              { k: "Focus", v: "Policyholder Data" },
            ].map((s) => (
              <div key={s.k} className="glass-card sheen p-5">
                <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                  {s.k}
                </div>
                <div className="mt-2 font-[family:var(--font-space-grotesk)] text-3xl font-semibold text-text-primary">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-secondary py-20" id="insurance-controls">
        <div className="container-ivalue">
          <ScrollReveal>
            <div className="glass-card p-6">
              <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                IRDAI domains
              </div>
              <h2 className="mt-2 text-2xl font-extrabold tracking-[-0.02em] text-text-primary md:text-3xl">
                10 domains
              </h2>
              <div className="mt-6 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
                {IRDAI_DOMAINS.map((d) => (
                  <div
                    key={d}
                    className="rounded-xl border border-border-subtle bg-white/5 px-3 py-2 text-sm text-text-secondary"
                  >
                    {d}
                  </div>
                ))}
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>

      <section className="bg-background-primary py-20" id="irdai-catalog">
        <div className="container-ivalue">
          <ScrollReveal>
            <div>
              <h2 className="text-3xl font-extrabold tracking-[-0.02em] text-text-primary md:text-5xl">
                IRDAI control catalog
              </h2>
              <p className="mt-3 max-w-3xl text-lg text-text-secondary">
                Seeded with sample controls (expandable to 70+ in the next phase).
              </p>
            </div>
          </ScrollReveal>

          <div className="mt-10">
            <GenericCatalogTable
              data={IRDAI_CONTROLS}
              columns={columns}
              csvColumns={[
                { header: "Control ID", accessorKey: "controlId" },
                { header: "Domain", accessorKey: "domain" },
                { header: "Requirement", accessorKey: "requirement" },
                { header: "Insurance Context", accessorKey: "insuranceContext" },
                { header: "Minimum Baseline", accessorKey: "minimumBaseline" },
                { header: "Evidence", accessorKey: "evidence" },
                { header: "Owner", accessorKey: "owner" },
                { header: "Frequency", accessorKey: "frequency" },
                { header: "Technology Enablers", accessorKey: "technologyEnablers" },
                { header: "Test Method", accessorKey: "testMethod" },
                { header: "Common Findings", accessorKey: "commonFindings" },
                { header: "Severity", accessorKey: "severity" },
                { header: "Automation", accessorKey: "automation" },
              ]}
            />
          </div>
        </div>
      </section>
    </div>
  );
}
